/**
 * Catálogo Oficial de Municipios y Departamentos de El Salvador (CAT-013 MH)
 * y funciones de resolución de ciudad y departamento para órdenes y clientes.
 */

export const DEPARTMENTS: Record<string, string> = {
    '01': 'Ahuachapán',
    '02': 'Santa Ana',
    '03': 'Sonsonate',
    '04': 'Chalatenango',
    '05': 'La Libertad',
    '06': 'San Salvador',
    '07': 'Cuscatlán',
    '08': 'La Paz',
    '09': 'Cabañas',
    '10': 'San Vicente',
    '11': 'Usulután',
    '12': 'San Miguel',
    '13': 'Morazán',
    '14': 'La Unión'
};

export const MUNICIPALITIES: Record<string, Record<string, string>> = {
    '01': {
        '01': 'Ahuachapán', '02': 'Apaneca', '03': 'Atiquizaya', '04': 'Concepción de Ataco',
        '05': 'El Refugio', '06': 'Guaymango', '07': 'Jujutla', '08': 'San Francisco Menéndez',
        '09': 'San Lorenzo', '10': 'San Pedro Puxtla', '11': 'Tacuba', '12': 'Turín'
    },
    '02': {
        '01': 'Candelaria de la Frontera', '02': 'Chalchuapa', '03': 'Coatepeque', '04': 'El Congo',
        '05': 'El Porvenir', '06': 'Masahuat', '07': 'Metapán', '08': 'San Antonio Pajonal',
        '09': 'San Sebastián Salitrillo', '10': 'Santa Ana', '11': 'Santa Rosa Guachipilín',
        '12': 'Santiago de la Frontera', '13': 'Texistepeque'
    },
    '03': {
        '01': 'Acajutla', '02': 'Armenia', '03': 'Caluco', '04': 'Cuisnahuat',
        '05': 'Izalco', '06': 'Juayúa', '07': 'Nahuizalco', '08': 'Nahulingo',
        '09': 'Salcoatitán', '10': 'San Antonio del Monte', '11': 'San Julián',
        '12': 'Santa Catarina Masahuat', '13': 'Santa Isabel Ishuatán', '14': 'Santo Domingo de Guzmán',
        '15': 'Sonsonate', '16': 'Sonzacate'
    },
    '04': {
        '01': 'Agua Caliente', '02': 'Arcatao', '03': 'Azacualpa', '04': 'Chalatenango',
        '05': 'Citalá', '06': 'Comalapa', '07': 'Concepción Quezaltepeque', '08': 'Dulce Nombre de María',
        '09': 'El Carrizal', '10': 'El Paraíso', '11': 'La Laguna', '12': 'La Palma',
        '13': 'La Reina', '14': 'Las Vueltas', '15': 'Nombre de Jesús', '16': 'Nueva Concepción',
        '17': 'Nueva Trinidad', '18': 'Ojos de Agua', '19': 'Potonico', '20': 'San Antonio de la Cruz',
        '21': 'San Antonio Los Ranchos', '22': 'San Fernando', '23': 'San Francisco Lempa',
        '24': 'San Francisco Morazán', '25': 'San Ignacio', '26': 'San Isidro Labrador',
        '27': 'San José Cancasque', '28': 'San José Las Flores', '29': 'San Luis del Carmen',
        '30': 'San Miguel de Mercedes', '31': 'San Rafael', '32': 'Santa Rita', '33': 'Tejutla'
    },
    '05': {
        '01': 'Antiguo Cuscatlán', '02': 'Chiltiupán', '03': 'Ciudad Arce', '04': 'Colón',
        '05': 'Comasagua', '06': 'Huizúcar', '07': 'Jayaque', '08': 'Jicalapa',
        '09': 'La Libertad', '10': 'Nuevo Cuscatlán', '11': 'Santa Tecla', '12': 'Quezaltepeque',
        '13': 'Sacacoyo', '14': 'San José Villanueva', '15': 'San Juan Opico', '16': 'San Matías',
        '17': 'San Pablo Tacachico', '18': 'Talnique', '19': 'Tamanique', '20': 'Teotepeque',
        '21': 'Tepecoyo', '22': 'Zaragoza'
    },
    '06': {
        '01': 'San Salvador', '02': 'Aguilares', '03': 'Apopa', '04': 'Ayutuxtepeque',
        '05': 'Cuscatancingo', '06': 'Ciudad Delgado', '07': 'El Paisnal', '08': 'Guazapa',
        '09': 'Ilopango', '10': 'Mejicanos', '11': 'Nejapa', '12': 'Panchimalco',
        '13': 'Rosario de Mora', '14': 'San Marcos', '15': 'San Martín', '16': 'Santiago Texacuangos',
        '17': 'Santo Tomás', '18': 'Soyapango', '19': 'Tonacatepeque'
    },
    '07': {
        '01': 'Cojutepeque', '02': 'Candelaria', '03': 'El Carmen', '04': 'El Rosario',
        '05': 'Monte San Juan', '06': 'Oratorio de Concepción', '07': 'San Bartolomé Perulapía',
        '08': 'San Cristóbal', '09': 'San José Guayabal', '10': 'San Pedro Perulapán',
        '11': 'San Rafael Cedros', '12': 'San Ramón', '13': 'Santa Cruz Analquito',
        '14': 'Santa Cruz Michapa', '15': 'Suchitoto', '16': 'Tenancingo'
    },
    '08': {
        '01': 'Zacatecoluca', '02': 'Cuyultitán', '03': 'El Rosario', '04': 'Jerusalén',
        '05': 'Mercedes La Ceiba', '06': 'Olocuilta', '07': 'Paraíso de Osorio', '08': 'San Antonio Masahuat',
        '09': 'San Emigdio', '10': 'San Francisco Chinameca', '11': 'San Juan Nonualco',
        '12': 'San Juan Talpa', '13': 'San Juan Tepezontes', '14': 'San Luis La Herradura',
        '15': 'San Luis Talpa', '16': 'San Miguel Tepezontes', '17': 'San Pedro Masahuat',
        '18': 'San Pedro Nonualco', '19': 'San Rafael Obrajuelo', '20': 'Santa María Ostuma',
        '21': 'Santiago Nonualco', '22': 'Tapalhuaca'
    },
    '09': {
        '01': 'Sensuntepeque', '02': 'Cinquera', '03': 'Dolores', '04': 'Guacotecti',
        '05': 'Ilobasco', '06': 'Jutiapa', '07': 'San Isidro', '08': 'Tejutepeque', '09': 'Victoria'
    },
    '10': {
        '01': 'San Vicente', '02': 'Apastepeque', '03': 'Guadalupe', '04': 'San Cayetano Istepeque',
        '05': 'San Esteban Catarina', '06': 'San Ildefonso', '07': 'San Lorenzo', '08': 'San Sebastián',
        '09': 'Santa Clara', '10': 'Santo Domingo', '11': 'Tecoluca', '12': 'Tepetitán', '13': 'Verapaz'
    },
    '11': {
        '01': 'Usulután', '02': 'Alegría', '03': 'Berlín', '04': 'California', '05': 'Concepción Batres',
        '06': 'El Triunfo', '07': 'Ereguayquín', '08': 'Estanzuelas', '09': 'Jiquilisco',
        '10': 'Jucuapa', '11': 'Jucuarán', '12': 'Mercedes Umaña', '13': 'Nueva Granada',
        '14': 'Ozatlán', '15': 'Puerto El Triunfo', '16': 'San Agustín', '17': 'San Buenaventura',
        '18': 'San Dionisio', '19': 'San Francisco Javier', '20': 'Santa Elena', '21': 'Santa María',
        '22': 'Santiago de María', '23': 'Tecapán'
    },
    '12': {
        '01': 'San Miguel', '02': 'Carolina', '03': 'Chapeltique', '04': 'Chinameca', '05': 'Chirilagua',
        '06': 'Ciudad Barrios', '07': 'Comacarán', '08': 'El Tránsito', '09': 'Lolotique',
        '10': 'Moncagua', '11': 'Nueva Guadalupe', '12': 'Nuevo Edén de San Juan', '13': 'Quelepa',
        '14': 'San Antonio del Mosco', '15': 'San Gerardo', '16': 'San Jorge', '17': 'San Luis de la Reina',
        '18': 'San Rafael Oriente', '19': 'Sesori', '20': 'Uluazapa'
    },
    '13': {
        '01': 'San Francisco Gotera', '02': 'Arambala', '03': 'Cacaopera', '04': 'Chilanga',
        '05': 'Corinto', '06': 'Delicias de Concepción', '07': 'El Carrizal', '08': 'El Rosario',
        '09': 'Gualococti', '10': 'Guatajiagua', '11': 'Joateca', '12': 'Jocoaitique',
        '13': 'Jocoro', '14': 'Lolotiquillo', '15': 'Meanguera', '16': 'Osicala',
        '17': 'Perquín', '18': 'San Carlos', '19': 'San Fernando', '20': 'San Isidro',
        '21': 'San Simón', '22': 'Sensembra', '23': 'Sociedad', '24': 'Torola',
        '25': 'Yamabal', '26': 'Yoloaiquín'
    },
    '14': {
        '01': 'La Unión', '02': 'Anamorós', '03': 'Bolívar', '04': 'Concepción de Oriente',
        '05': 'Conchagua', '06': 'El Carmen', '07': 'El Sauce', '08': 'Intipucá',
        '09': 'Lislique', '10': 'Meanguera del Golfo', '11': 'Nueva Esparta', '12': 'Pasaquina',
        '13': 'Polorós', '14': 'San Alejo', '15': 'San José', '16': 'Santa Rosa de Lima',
        '17': 'Yayantique', '18': 'Yucuaiquín'
    }
};

const normalizeCode = (val: any): string => {
    if (!val) return '';
    const str = String(val).trim().replace(/^[DM]/i, '');
    return str.length === 1 ? `0${str}` : str;
};

export const resolveMunicipalityName = (deptoCode: any, muniCode: any): string => {
    const d = normalizeCode(deptoCode);
    let m = normalizeCode(muniCode);
    if (m.includes('-')) {
        const parts = m.split('-');
        m = normalizeCode(parts[1] || parts[0]);
    } else if (m.length === 4) {
        m = normalizeCode(m.substring(2));
    }
    if (d && m && MUNICIPALITIES[d]?.[m]) {
        return MUNICIPALITIES[d][m];
    }
    return '';
};

export const resolveDepartmentName = (deptoCode: any): string => {
    const d = normalizeCode(deptoCode);
    return DEPARTMENTS[d] || '';
};

/**
 * Resuelve el nombre de la ciudad/municipio a partir de todas las fuentes disponibles:
 * 1. Campo city / City de la orden
 * 2. Dirección consultada de SAP (clientAddress.city / City)
 * 3. Campo city / City del cliente
 * 4. Mapeo por código de municipio y departamento (codeMunicipality + codeDepartament)
 * 5. Departamento como fallback geográfico
 */
export const resolveCityFromOrder = (order: any, clientAddress?: any, costumer?: any): string => {
    if (order?.city && typeof order.city === 'string' && order.city.trim() !== '') return order.city.trim();
    if (order?.City && typeof order.City === 'string' && order.City.trim() !== '') return order.City.trim();
    if (clientAddress?.city && typeof clientAddress.city === 'string' && clientAddress.city.trim() !== '') return clientAddress.city.trim();
    if (clientAddress?.City && typeof clientAddress.City === 'string' && clientAddress.City.trim() !== '') return clientAddress.City.trim();
    if (costumer?.City && typeof costumer.City === 'string' && costumer.City.trim() !== '') return costumer.City.trim();
    if (costumer?.city && typeof costumer.city === 'string' && costumer.city.trim() !== '') return costumer.city.trim();

    const orderMuni = resolveMunicipalityName(order?.codeDepartament, order?.codeMunicipality);
    if (orderMuni) return orderMuni;

    const addrMuni = resolveMunicipalityName(clientAddress?.codeDepartament, clientAddress?.codeMunicipality);
    if (addrMuni) return addrMuni;

    const orderDepto = resolveDepartmentName(order?.codeDepartament);
    if (orderDepto) return orderDepto;

    if (clientAddress?.state && typeof clientAddress.state === 'string' && clientAddress.state.trim() !== '') {
        return clientAddress.state.trim();
    }
    if (order?.state && typeof order.state === 'string' && order.state.trim() !== '') {
        return order.state.trim();
    }

    return '';
};

/**
 * Resuelve el nombre del departamento
 */
export const resolveStateFromOrder = (order: any, clientAddress?: any, costumer?: any): string => {
    if (order?.state && typeof order.state === 'string' && order.state.trim() !== '') return order.state.trim();
    if (order?.State && typeof order.State === 'string' && order.State.trim() !== '') return order.State.trim();
    if (clientAddress?.state && typeof clientAddress.state === 'string' && clientAddress.state.trim() !== '') return clientAddress.state.trim();
    if (clientAddress?.State && typeof clientAddress.State === 'string' && clientAddress.State.trim() !== '') return clientAddress.State.trim();

    const d = resolveDepartmentName(order?.codeDepartament || clientAddress?.codeDepartament);
    if (d) return d;

    return '';
};
